
const digest = '2cce1554e8d17325e78c011170f842b5f297c504f5af17753df1a49de95004d7';
const classes = {"wrapper":"_wrapper_303q2_1","item":"_item_303q2_7","button":"_button_303q2_12"};
const css = `._wrapper_303q2_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  gap: 30px;
}
._wrapper_303q2_1 ._item_303q2_7 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_303q2_1 ._item_303q2_7 ._button_303q2_12 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  